import { render, staticRenderFns } from "./province.vue?vue&type=template&id=5d2470ef&scoped=true"
import script from "./province.vue?vue&type=script&lang=js"
export * from "./province.vue?vue&type=script&lang=js"
import style0 from "./province.vue?vue&type=style&index=0&id=5d2470ef&prod&lang=scss&scoped=true"
import style1 from "./province.vue?vue&type=style&index=1&id=5d2470ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2470ef",
  null
  
)

export default component.exports